import CookieNameSpace from '~/const/cookie';
import { getTokenFromStorage } from '~/helpers/storage';

// composables/useAuthToken.ts
let cachedToken: string | null = null;
let tokenPromise: Promise<string | null | undefined> | null = null;

export const useAuthToken = () => {
	const getAuthToken = async () => {
		// Если уже есть в кэше -getTokenFromStorage возвращаем
		if (cachedToken) {
			return cachedToken;
		}

		// Если уже идет запрос - ждем его
		if (tokenPromise) {
			return tokenPromise;
		}

		// Запрашиваем токен
		tokenPromise = getTokenFromStorage(CookieNameSpace.getAccessToken)
			.then((token) => {
				cachedToken = token || null;
				tokenPromise = null;
				return token;
			})
			.catch((error) => {
				tokenPromise = null;
				throw error;
			});

		return tokenPromise;
	};

	const clearAuthToken = () => {
		cachedToken = null;
	};

	return {
		getAuthToken,
		clearAuthToken
	};
};
